import { z, isoZ } from 'my-zod'

export const outfitterOrderWarehouseAllocationsModel = z
  .object({
    id: z.string(),
    outfitterOrderLineId: z.string().max(36),
    warehouseId: z.number(),
    quantityConsumed: z.number().nullable(),
    associationDate: isoZ.instant().nullable(),
    userId: z.number().nullable(),
    deletedDate: isoZ.instant().nullable()
  })
  .setCFV({
    quantityConsumedRequired(val) {
      if (!val.quantityConsumed && val.quantityConsumed !== 0) {
        return {
          message: 'Please provide Quantity.',
          path: ['quantityConsumed']
        }
      }
    }
  })

export type outfitterOrderWarehouseAllocationsModel = z.infer<typeof outfitterOrderWarehouseAllocationsModel>
